import React from 'react';
import { Box, Card, CardContent, Typography, Button, Avatar, alpha } from '@mui/material';
import { ArrowForward as ArrowIcon } from '@mui/icons-material';

const ActionCard = ({ icon, title, description, onClick, color, buttonText = '管理する' }) => (
  <Card 
    onClick={onClick}
    sx={{ 
      boxShadow: '0 4px 20px 0 rgba(0,0,0,0.1)', 
      borderRadius: 2, 
      height: '100%',
      transition: 'all 0.3s ease-in-out',
      cursor: 'pointer',
      '&:hover': {
        transform: 'translateY(-8px)',
        boxShadow: '0 12px 28px 0 rgba(0,0,0,0.15)',
        '& .arrow-icon': {
          transform: 'translateX(4px)',
        }
      }
    }}
  >
    <CardContent sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <Avatar
          sx={{
            backgroundColor: alpha(color, 0.1),
            color: color,
            height: 48,
            width: 48,
            mr: 2
          }}
        >
          {icon}
        </Avatar>
        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
          {title}
        </Typography>
      </Box>
      
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {description}
      </Typography>
      
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
        <Button 
          endIcon={<ArrowIcon className="arrow-icon" sx={{ transition: 'transform 0.2s' }} />}
          sx={{ 
            color: color,
            '&:hover': {
              backgroundColor: alpha(color, 0.05),
            }
          }}
        >
          {buttonText}
        </Button>
      </Box>
    </CardContent>
  </Card>
);

export default ActionCard;
